'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import I18n from 'I18n';
import HomepageLabelledInput from '../components/HomepageLabelledInput';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UrlPattern from 'PatternValidationJS/patterns/Url';
import InputUtil from '../util/InputUtil';
import { navigateTo } from '../util/History';
import { TESTS } from '../constants/Paths';

var ErrorPageForm = function ErrorPageForm() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      websiteUrl = _useState2[0],
      setWebsiteUrl = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      ignoreValidity = _useState4[0],
      setIgnoreValidity = _useState4[1];

  var isWebsiteValid = function isWebsiteValid() {
    return UrlPattern.test(websiteUrl);
  };

  var buttonClicked = function buttonClicked(event) {
    // Don't ignore validity anymore
    setIgnoreValidity(false);

    if (isWebsiteValid()) {
      var parsedWebsiteUrl = InputUtil.parseWebsiteUrl(websiteUrl); // Go to the results page

      navigateTo(TESTS + "/" + parsedWebsiteUrl);
    }

    event.preventDefault();
    return false;
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    return false;
  };

  var getButtonKey = function getButtonKey() {
    return 'error.form.button';
  };

  return /*#__PURE__*/_jsxs("form", {
    className: "website-input",
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx(HomepageLabelledInput, {
      type: "url",
      errorText: I18n.text('error.form.website.errorText'),
      labelText: I18n.text('error.form.website.text'),
      onChange: function onChange(event) {
        var value = event.target.value;
        setWebsiteUrl(value);
      },
      onBlur: function onBlur(event) {
        var value = event.target.value;
        setWebsiteUrl(value.trim());
      },
      value: websiteUrl,
      isValid: function isValid() {
        return ignoreValidity || isWebsiteValid();
      }
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("button", {
      className: "button primary",
      type: "submit",
      onClick: buttonClicked,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: getButtonKey()
      })
    })]
  });
};

export default ErrorPageForm;